export default "__VITE_ASSET__B_SUc$4j__"